<template>
  <div class="zgdxkd-page">
    <!-- 头部横幅 -->
    <div class="banner-img">
      <img src="@/assets/ad/zgdx_kuandai/20250919143343249.jpg" alt="中国电信">
    </div>

    <!-- 表单卡片 -->
    <div class="form-card">
      <!-- 地区 -->
      <div class="form-group">
        <span class="label require">地区</span>
        <div class="region-select" @click="showCityPicker = true">
          <span :class="['placeholder', { 'has-value': formData.city }]">{{ formData.city || '报装城市' }}</span>
          <div class="right">
            <span class="change-hint">可更改</span>
            <span class="arrow"></span>
          </div>
        </div>
      </div>

      <!-- 姓名 -->
      <div class="form-group">
        <span class="label require">姓名</span>
        <div class="input-wrap">
          <input type="text" v-model="formData.name" placeholder="请输入办理人姓名" maxlength="50">
        </div>
      </div>

      <!-- 联系方式 -->
      <div class="form-group">
        <span class="label require">联系方式</span>
        <div class="input-wrap">
          <input type="tel" v-model="formData.phone" placeholder="请输入您的手机号码" maxlength="11">
        </div>
      </div>

      <!-- 验证码 -->
      <div class="form-group">
        <span class="label require">验证码</span>
        <div class="input-wrap">
          <input type="tel" v-model="formData.code" placeholder="请输入验证码" maxlength="6">
        </div>
        <button class="code-btn" @click="getCode" :disabled="codeSending">
          {{ codeSending ? countdown + 's' : '获取验证码' }}
        </button>
      </div>

      <!-- 身份证号 -->
      <div class="form-group id-card">
        <span class="label require">身份证号</span>
        <div class="input-wrap">
          <input type="text" v-model="formData.idCard" placeholder="未满18周岁请勿下单" maxlength="18">
        </div>
      </div>

      <!-- 详细地址 -->
      <div class="form-group">
        <span class="label require">详细地址</span>
        <div class="input-wrap">
          <input type="text" v-model="formData.address" placeholder="街道门牌号*小区*层*房号" maxlength="100">
        </div>
      </div>

      <!-- 提交按钮 -->
      <div class="submit-wrap">
        <button class="submit-btn" @click="onSubmit">
          <img src="@/assets/ad/zgdx_kuandai/20221116184505955.png" alt="立即预约">
        </button>
      </div>

      <!-- 协议 -->
      <div class="agreement">
        <input type="checkbox" class="checkbox" v-model="formData.agreed" id="agreeCheck">
        <div class="agree-text">
          我已阅读并同意<span class="link" @click="showAgreement">《入网许可协议&amp;个人信息收集说明》</span>
        </div>
      </div>
    </div>

    <!-- 注 -->
    <div class="notice">
      <p>注：1、为保证电信人员上门办理，请务必准确详细填写安装地址信息。</p>
      <p>2、佛山地区初装费政策略有差异，具体以电信人员上门沟通为准。</p>
    </div>

    <!-- 滚动实时预约提示 -->
    <div class="scroll-tips" v-if="orderTips.length > 0">
      <span class="label-icon">&#x1F4AC;</span>
      <div class="scroll-wrap" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
        <vue-seamless-scroll
          :data="orderTips"
          :class-option="scrollOption"
          class="seamless-scroll">
          <div class="scroll-item" v-for="(item, index) in orderTips" :key="index">
            {{ item.name }} {{ item.phone }} 已预约 {{ item.time }}分钟前
          </div>
        </vue-seamless-scroll>
      </div>
    </div>

    <!-- 推广图片 -->
    <div class="promo-img">
      <img src="@/assets/ad/zgdx_kuandai/20250911100029363.png" alt="套餐推荐">
    </div>
    <div class="promo-img full">
      <img src="@/assets/ad/zgdx_kuandai/20250909165852910.png" alt="千兆光纤">
    </div>
    <div class="promo-img full">
      <img src="@/assets/ad/zgdx_kuandai/178211005595600000.jpg" alt="5G套餐">
    </div>
    <div class="promo-img">
      <img src="@/assets/ad/zgdx_kuandai/20250909171246291.jpg" alt="优惠活动">
    </div>
    <div class="promo-img">
      <img src="@/assets/ad/zgdx_kuandai/20250909171300513.jpg" alt="更多优惠">
    </div>

    <!-- 页脚 -->
    <div class="footer-note">
      本页面仅用于业务展示与预约办理<br>
      最终解释权归中国电信所有
    </div>

    <!-- 城市选择弹窗 -->
    <van-popup v-model="showCityPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="cityColumns"
        @cancel="showCityPicker = false"
        @confirm="onCityConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, Picker, Toast } from 'vant';
import Vue from 'vue';

Vue.use(Popup).use(Picker);

export default {
  name: 'Zgdxkd',
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  data() {
    return {
      formData: {
        city: '',
        name: '',
        phone: '',
        code: '',
        idCard: '',
        address: '',
        agreed: true,
      },
      showCityPicker: false,
      cityColumns: ['佛山', '广州', '深圳', '东莞', '中山', '珠海', '惠州', '江门', '肇庆', '清远'],
      codeSending: false,
      countdown: 60,
      codeTimer: null,
      orderTips: [
        { name: '陈**', phone: '159****4321', time: 6 },
        { name: '李*', phone: '183****6666', time: 6 },
        { name: '潘**', phone: '152****5678', time: 5 },
        { name: '杨*', phone: '188****2042', time: 5 },
        { name: '尹**', phone: '187****2520', time: 3 },
        { name: '胡*', phone: '188****6868', time: 2 },
        { name: '金*', phone: '187****1661', time: 2 },
        { name: '唐**', phone: '152****6688', time: 1 },
      ],
      scrollOption: {
        singleHeight: 0,
        waitTime: 3000,
      },
    };
  },
  beforeDestroy() {
    this.clearCodeTimer();
  },
  methods: {
    getCode() {
      if (this.codeSending) return;
      if (!this.formData.phone || !/^1[3-9]\d{9}$/.test(this.formData.phone)) {
        Toast('请输入正确的手机号码');
        return;
      }
      this.codeSending = true;
      this.countdown = 60;
      this.codeTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearCodeTimer();
          this.codeSending = false;
        }
      }, 1000);

      // TODO: 调用获取验证码接口
      // http('sendSms', { phone: this.formData.phone });
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
    },
    onCityConfirm(value) {
      this.formData.city = value;
      this.showCityPicker = false;
    },
    showAgreement() {
      // TODO: 显示协议详情
      Toast('《入网许可协议&个人信息收集说明》');
    },
    pauseScroll() {
      // vue-seamless-scroll handles this via class-option
    },
    resumeScroll() {
      // vue-seamless-scroll handles this via class-option
    },
    onSubmit() {
      if (!this.formData.agreed) {
        Toast('请阅读并同意《入网许可协议&个人信息收集说明》');
        return;
      }
      if (!this.formData.name) {
        Toast('请输入办理人姓名');
        return;
      }
      if (!this.formData.phone || !/^1[3-9]\d{9}$/.test(this.formData.phone)) {
        Toast('请输入正确的手机号码');
        return;
      }
      if (!this.formData.code) {
        Toast('请输入验证码');
        return;
      }
      if (!this.formData.idCard) {
        Toast('请输入身份证号');
        return;
      }
      if (this.formData.idCard.length < 18) {
        Toast('请输入完整的18位身份证号码');
        return;
      }
      if (!this.formData.address) {
        Toast('请输入详细地址');
        return;
      }

      Toast('预约提交成功！客服将在24小时内与您联系。');
      // TODO: 调用提交接口
      // http('simOrder', params);
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.zgdxkd-page {
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  background: #F12117;
  max-width: 540px;
  margin: 0 auto;
  -webkit-font-smoothing: antialiased;
  line-height: 1.5;
  font-size: 14px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

img {
  max-width: 100%;
  display: block;
}

/* Banner */
.banner-img {
  width: 100%;
  line-height: 0;
}
.banner-img img {
  width: 100%;
}

/* Form Card */
.form-card {
  margin: 16px 12px 0;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.form-group {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 80px;
  padding: 8px 16px;
  background: #fff;
}
.form-group + .form-group {
  border-top: 1px solid #ececec;
}

.form-group .label {
  font-size: clamp(22px, 4.5vw, 30px);
  color: #333;
  white-space: nowrap;
  flex-shrink: 0;
  width: clamp(100px, 22vw, 160px);
  font-weight: 500;
}
.form-group .label.require::before {
  content: '*';
  color: #F12117;
  margin-right: 4px;
}

.form-group .input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
}
.form-group .input-wrap input {
  flex: 1;
  border: none;
  outline: none;
  font-size: clamp(20px, 4.5vw, 30px);
  color: #333;
  background: transparent;
  height: 60px;
  width: 100%;
  font-family: inherit;
}
.form-group .input-wrap input::placeholder {
  color: #c0c0c0;
}

/* Region selector */
.region-select {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  height: 60px;
}
.region-select .placeholder {
  color: #c0c0c0;
  font-size: clamp(20px, 4.5vw, 30px);
}
.region-select .placeholder.has-value {
  color: #333;
}
.region-select .right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.region-select .right .change-hint {
  color: #F12117;
  font-size: clamp(18px, 4vw, 24px);
}
.region-select .right .arrow {
  width: clamp(20px, 5vw, 28px);
  height: clamp(20px, 5vw, 28px);
  border-right: 4px solid #999;
  border-bottom: 4px solid #999;
  transform: rotate(-45deg);
  display: inline-block;
}

/* Code button */
.code-btn {
  flex-shrink: 0;
  padding: 0 0 0 16px;
  background: none;
  border: none;
  border-left: 1px solid #ececec;
  font-size: clamp(20px, 4.5vw, 28px);
  color: #F12117;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
  height: 60px;
  display: flex;
  align-items: center;
}
.code-btn:active {
  opacity: 0.7;
}
.code-btn:disabled {
  color: #999;
  cursor: not-allowed;
}

/* Submit button */
.submit-wrap {
  padding: 30px 16px 0;
}
.submit-btn {
  width: 100%;
  border: none;
  cursor: pointer;
  display: block;
  animation: breath 1.5s ease-in-out infinite;
  padding: 0;
  background: none;
}
.submit-btn img {
  width: 100%;
  display: block;
}
@keyframes breath {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
}

/* Agreement */
.agreement {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 16px 20px;
}
.agreement .checkbox {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  margin-top: 4px;
  appearance: none;
  -webkit-appearance: none;
  border: 2px solid #ccc;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  background: #fff;
}
.agreement .checkbox:checked {
  background: #FEE405;
  border-color: #FEE405;
}
.agreement .checkbox:checked::after {
  content: '';
  position: absolute;
  left: 10px;
  top: 3px;
  width: 14px;
  height: 22px;
  border: solid #333;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.agreement .agree-text {
  flex: 1;
  font-size: clamp(20px, 4.5vw, 28px);
  color: #666;
  line-height: 1.5;
}
.agreement .agree-text .link {
  color: #F12117;
  cursor: pointer;
}

/* Notice */
.notice {
  padding: 30px 20px;
  text-align: left;
}
.notice p {
  font-size: clamp(16px, 3.5vw, 20px);
  color: #fff;
  line-height: 1.6;
}

/* Scrolling Tips */
.scroll-tips {
  margin: 16px auto;
  width: 100%;
  max-width: calc(100% - 24px);
  background: linear-gradient(135deg, #fff8f6, #fff1ee);
  border-radius: 40px;
  padding: 0 16px 0 24px;
  height: clamp(52px, 12vw, 72px);
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 12px rgba(241,33,23,0.08);
}
.scroll-tips .label-icon {
  font-size: clamp(22px, 5vw, 30px);
  flex-shrink: 0;
}
.scroll-tips .scroll-wrap {
  flex: 1;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.seamless-scroll {
  height: 100%;
}
.scroll-item {
  height: clamp(52px, 12vw, 72px);
  display: flex;
  align-items: center;
  font-size: clamp(18px, 4vw, 22px);
  color: #333;
  font-weight: 500;
}

/* Promo Images */
.promo-img {
  width: 100%;
  line-height: 0;
}
.promo-img img {
  width: 100%;
}

/* Footer */
.footer-note {
  padding: 0.4rem 0.24rem;
  text-align: center;
  font-size: clamp(20px, 4.5vw, 28px);
  color: rgba(255,255,255,0.6);
  line-height: 1.6;
  background: rgba(0,0,0,0.05);
}
</style>
